import React, { useRef } from 'react';

type Props = {
  item: any;
  selectedImage: string;
  selectImage: (id:string) => void;
};

function ImageLibraryItem({ item, selectedImage, selectImage }: Props) {

  return (
    <li className={item.id === selectedImage ? 'active' : ''} >
      <button 
        onClick={() => {selectImage(item?.id)}}
        style={{backgroundImage: `url(${item?.urls?.thumb})`}}
      >
      </button>
      <p className="cc">
        <a href={item?.user?.links?.html} target="_blank">{item?.user?.username}</a>
      </p>
    </li>
  );
}

ImageLibraryItem.defaultProps = {
};

export default ImageLibraryItem;